import React, { Component } from 'react'
import propTypes from 'prop-types'
import { withRouter } from 'react-router'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import { Formik, Form, Field } from 'formik'
import mapValues from 'lodash/mapValues'
import Button from '@components/Button'
import FormError from '@components/FormError/FormError'
import Input from '@components/Form/Input'
import { Autocomplete } from '@components/Form/Autocomplete'
import { getAtheneumContactSuggestions, configurationApi } from '@atheneum/api'

import DepartmentResponsibleUsersStore from './department-responsible-users.store'

class DepartmentResponsibleUsersPage extends Component {
  static propTypes = {
    growlStore: propTypes.object
  }
  state = { error: null }

  constructor (props) {
    super(props)

    extendObservable(this, {
      departmentResponsibleUserStore: new DepartmentResponsibleUsersStore()
    })

    this.loadData()
  }

  loadData = () => {
    const { departmentResponsibleUserStore } = this

    return departmentResponsibleUserStore.getAll()
  }

  getEmployees = (query = '') => {
    if (!query) return Promise.resolve([])

    return getAtheneumContactSuggestions(query, { select: true })
  }

  save = data => {
    data = mapValues(data, value => (value.id ? value.id : value))

    return configurationApi.updateDepartmentResponsibleUsers(data)
  }

  handleSubmit = (values, actions) => {
    const { growlStore } = this.props

    this.save(values)
      .then(this.loadData)
      .then(() => {
        growlStore.showSuccess(
          'Department Responsible Users successfully saved'
        )
      })
      .catch(({ message }) => {
        this.setState({ error: message })
        growlStore.showError(message)
        actions.setSubmitting(false)
      })
  }

  itemToString = item => {
    const { employees } = this.departmentResponsibleUserStore
    if (item && item.fullName) return item.fullName

    const employee = employees.find(({ id }) => Number(id) === Number(item))

    if (employee) return employee.fullName

    return ''
  }

  render () {
    const { loading, entries } = this.departmentResponsibleUserStore

    if (loading === true) {
      return null
    }

    return (
      <div className='department-responsible-users-form-wrapper'>
        <Formik
          initialValues={entries}
          onSubmit={this.handleSubmit}
          render={form => (
            <div className='expert-form'>
              <h1 className='expert-form__title'>
                Department Responsible Users
              </h1>
              <FormError error={this.state.error} />
              <Form onSubmit={form.handleSubmit}>
                <div className='expert-form__section'>
                  <Field
                    name='bdUser'
                    label='BD User'
                    itemToString={this.itemToString}
                    loadOptions={this.getEmployees}
                    component={Autocomplete}
                  />
                  <Field
                    name='ermUser'
                    label='ERM User'
                    itemToString={this.itemToString}
                    loadOptions={this.getEmployees}
                    component={Autocomplete}
                  />
                  <Field
                    name='accUser'
                    label='ACC User'
                    itemToString={this.itemToString}
                    loadOptions={this.getEmployees}
                    component={Autocomplete}
                  />
                  <Field
                    name='opsManager'
                    label='OPS Manager'
                    itemToString={this.itemToString}
                    loadOptions={this.getEmployees}
                    component={Autocomplete}
                  />
                  <Field name='bdEmail' label='BD Email' component={Input} />
                  <Field name='ermEmail' label='ERM Email' component={Input} />
                  <Field name='accEmail' label='ACC Email' component={Input} />
                  <Field
                    name='contractControllingEmail'
                    label='BD Email'
                    component={Input}
                  />
                  <Field
                    name='newProjectEmail'
                    label='New Project Email'
                    component={Input}
                  />
                  <Field
                    name='closedProjectEmail'
                    label='Closed Project Email'
                    component={Input}
                  />
                  <Field
                    name='opsManagmentEmail'
                    label='OPS Management Email'
                    component={Input}
                  />
                  <Field
                    name='controllingEmail'
                    label='Controlling email'
                    component={Input}
                  />
                </div>
                <div className='expert-form__section'>
                  <Button primary submit onClick={this.onSubmit}>
                    Save
                  </Button>
                </div>
              </Form>
            </div>
          )}
        />
      </div>
    )
  }
}

export default withRouter(
  inject('growlStore')(observer(DepartmentResponsibleUsersPage))
)
